import {
  configureStore,
  combineReducers,
  Middleware,
  AnyAction,
  Action,
} from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { authReducer } from "src/state/slices/authSlice";
import offcanvasReducer from "../slices/asideslice";
import { LOCAL_AUTH_STATE_KEY } from "src/utils/appConstants";

const rootReducer = combineReducers({
  auth: authReducer,
  offcanvas: offcanvasReducer,
});

const localStorageMiddleware: Middleware<RootState> = ({ getState }) => {
  return (next) => (action: Action) => {
    const result = next(action);
    if (
      action.type.startsWith("auth/") ||
      action.type.startsWith("offcanvas")
    ) {
      const { auth, offcanvas }: Partial<RootState> = getState();
      localStorage.setItem(
        LOCAL_AUTH_STATE_KEY,
        JSON.stringify({ auth, offcanvas })
      );
    }
    return result;
  };
};

const reHydrateStore = (): Partial<RootState> => {
  const res = localStorage.getItem(LOCAL_AUTH_STATE_KEY);
  if (res !== null) {
    return JSON.parse(res); // re-hydrate the store
  }
};

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: reHydrateStore(),
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(localStorageMiddleware);
  },
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export type AppDispatchType = ReturnType<typeof useAppDispatch>;
